import React, { createContext, useContext, useCallback, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "wa.lang";

const dict = {
  nl: {
    // nav / common
    "nav.woningen": "Woningen",
    "nav.koop": "Kopen",
    "nav.woningwaarde": "Woningwaarde",
    "nav.scamcheck": "Scam-check",
    "nav.prijzen": "Prijzen",
    "nav.dashboard": "Dashboard",
    "nav.login": "Inloggen",
    "nav.register": "Account aanmaken",
    "nav.logout": "Uitloggen",
    "nav.account": "Mijn account",
    "menu.profiel": "Zoekprofiel",
    "menu.vault": "Documentenkluis",
    "menu.alerts": "Woningalerts",
    "menu.reacties": "Mijn reacties",
    "menu.bezichtigingen": "Bezichtigingen",
    "menu.referrals": "Nodig vrienden uit",
    "menu.instellingen": "Instellingen",
    "menu.makelaar": "Makelaar-portaal",
    "menu.section.tenant": "Woningzoekende",
    "menu.section.broker": "Makelaar",
    "nav.premium": "Premium",
    // Premium hub
    "premium.seo.title": "WoningAlert Premium — alles wat je nodig hebt om sneller een woning te vinden",
    "premium.seo.desc": "Ontgrendel slimme tools, onbeperkte favorieten en slimme alerts. Één abonnement, alle voordelen.",
    "premium.hero.brand": "WoningAlert",
    "premium.hero.freeSub": "Ontgrendel alles wat je nodig hebt om sneller en slimmer een woning te vinden.",
    "premium.hero.activeSub": "Je Premium-tools staan hieronder klaar.",
    "premium.hero.cta": "Ontgrendel WoningAlert Premium",
    "premium.pill.active": "Premium actief",
    "premium.pill.inactive": "Premium",
    "premium.card.freeLabel": "Gratis",
    "premium.card.proLabel": "Premium",
    "premium.card.locked": "Vergrendeld",
    "premium.card.unlock": "Ontgrendel",
    "premium.card.available": "Beschikbaar",
    "premium.card.open": "Open tool",
    "premium.card.openFree": "Openen",
    "premium.card.coach.title": "Reactiecoach",
    "premium.card.coach.desc": "Laat een slimme assistent een sterke, persoonlijke reactiebrief schrijven op basis van jouw profiel en de woning.",
    "premium.card.coach.pro": "Onbeperkt reactiebrieven op elke woning",
    "premium.card.photo.title": "Foto-analyse",
    "premium.card.photo.desc": "Detecteer vocht, schimmel, slecht licht en onderhoud aan de hand van de woningfoto's.",
    "premium.card.photo.pro": "Onbeperkte foto-analyses",
    "premium.card.scam.title": "Scam Check",
    "premium.card.scam.desc": "Controleer een advertentie op verdachte signalen voordat je reageert of betaalt.",
    "premium.card.scam.free": "3 checks per week gratis",
    "premium.card.scam.pro": "Onbeperkte checks + prioriteit",
    "premium.card.match.title": "Persoonlijke Match Score",
    "premium.card.match.desc": "Zie in één oogopslag hoe goed een woning bij jouw profiel past.",
    "premium.card.match.free": "Basis match-score op elke woning",
    "premium.card.match.pro": "Volledige score + uitleg per criterium",
    "premium.card.vault.title": "Documentenkluis",
    "premium.card.vault.desc": "Zet documenten veilig klaar en genereer een compleet huurdossier in seconden.",
    "premium.card.vault.free": "Documenten veilig opslaan",
    "premium.card.vault.pro": "Slim huurdossier PDF-pakket in 1 klik",
    "premium.card.alerts.title": "Slimme woningalerts",
    "premium.card.alerts.desc": "Beheer je zoekprofielen en ontvang direct nieuwe matches.",
    "premium.card.alerts.free": "Basis alerts per e-mail",
    "premium.card.alerts.pro": "Meerdere zoekprofielen + push-prioriteit",
    "premium.card.favs.title": "Favorieten",
    "premium.card.favs.desc": "Bewaar woningen die je later wilt bekijken of waarop je wilt reageren.",
    "premium.card.favs.free": "Tot 10 favorieten",
    "premium.card.favs.pro": "Onbeperkte favorieten",
    "premium.footcta.title": "Sneller en slimmer een woning vinden",
    "premium.footcta.sub": "Ontgrendel alle slimme tools, onbeperkte favorieten en slimme alerts. Direct opzegbaar.",
    // Premium tools — shared
    "tools.locked.title": "Alleen voor Premium-leden",
    "tools.locked.sub": "Deze tool is onderdeel van WoningAlert Premium. Ontgrendel Premium om direct te starten.",
    "tools.locked.cta": "Ontgrendel Premium",
    "tools.coach.seoTitle": "Reactiecoach — WoningAlert Premium",
    "tools.coach.seoDesc": "Laat een slimme assistent een sterke reactiebrief schrijven op basis van je profiel en de woning.",
    "tools.coach.title": "Reactiecoach",
    "tools.coach.subtitle": "Krijg in seconden een sterke, persoonlijke reactiebrief.",
    "tools.coach.pickListing": "Kies een woning",
    "tools.coach.searchPh": "Zoek op stad, straat of titel",
    "tools.coach.noneFound": "Geen woningen gevonden.",
    "tools.coach.toneShort": "Kort & krachtig",
    "tools.coach.toneLong": "Uitgebreid",
    "tools.coach.extraLabel": "Extra informatie (optioneel)",
    "tools.coach.extraPh": "Bijv. verhuisreden, huisdieren, gezinssamenstelling…",
    "tools.coach.generate": "Genereer reactiebrief",
    "tools.coach.generating": "Genereren…",
    "tools.coach.error": "Kon geen reactiebrief genereren. Probeer het opnieuw.",
    "tools.coach.emptyHint": "Kies een woning links om te starten.",
    "tools.coach.readyHint": "Klaar om een reactie te genereren voor: {title}",
    "tools.coach.copy": "Kopieer",
    "tools.coach.copied": "Gekopieerd",
    "tools.coach.result.subject": "Onderwerp",
    "tools.coach.result.letter": "Reactiebrief",
    "tools.coach.result.tips": "Tips voor de opvolging",
    "tools.photo.seoTitle": "Foto-analyse — WoningAlert Premium",
    "tools.photo.seoDesc": "Analyseer woningfoto's op vocht, schimmel en achterstallig onderhoud.",
    "tools.photo.title": "Foto-analyse",
    "tools.photo.subtitle": "Ontdek vocht, schimmel en onderhoudspunten voor je reageert.",
    "tools.photo.pickListing": "Kies een woning om te analyseren",
    "tools.photo.searchPh": "Zoek op stad, straat of titel",
    "tools.photo.analyse": "Analyseer foto's",
    "tools.photo.analysing": "Analyseren…",
    "tools.photo.error": "Kon geen analyse uitvoeren. Probeer het opnieuw.",
    "tools.photo.emptyHint": "Kies een woning links om te starten.",
    "tools.photo.readyHint": "Klaar om foto's te analyseren voor: {title}",
    "tools.photo.result.score": "Algehele conditie-score",
    "tools.photo.result.positives": "Positieve punten",
    "tools.photo.result.concerns": "Aandachtspunten",
    "tools.photo.result.questions": "Vragen om te stellen bij de bezichtiging",
    "tools.photo.result.photoCount": "{n} foto's geanalyseerd",
    // Dashboard premium card
    "dash.premium.title": "WoningAlert Premium",
    "dash.premium.sub": "Je Premium-tools staan klaar.",
    "dash.premium.cta": "Open Premium",
    "dash.upsell.title": "Ontgrendel Premium",
    "dash.upsell.sub": "Bekijk alle Premium-tools die je nog niet gebruikt.",
    "dash.upsell.cta": "Bekijk Premium",
    "scam.nudge.title": "Deze check was gratis",
    "scam.nudge.body": "Met Premium krijg je onbeperkte Scam Checks, plus Reactiecoach en Foto-analyse.",
    "scam.nudge.cta": "Bekijk Premium",
    "scam.nudge.pricing": "Bekijk prijzen",
    "common.loading": "Laden…",
    "common.retry": "Probeer opnieuw",
    "common.error": "Er ging iets mis. Probeer het opnieuw.",
    "common.perMonth": "/mnd",
    "common.rooms": "kamers",
    "common.beds": "slaapk.",
    "common.match": "Match",
    "common.live": "Live",
    "common.soon": "Binnenkort",
    "common.viewAll": "Bekijk alles",
    "common.email": "E-mailadres",
    "common.password": "Wachtwoord",
    "common.name": "Naam",
    "common.back": "Terug",

    // home
    "home.hero.title": "Vind sneller jouw volgende woning",
    "home.hero.subtitle":
      "Huren of kopen? Ontdek woningen die écht bij je passen met ons unieke matchingsysteem.",
    "home.hero.cta": "Bekijk woningen",
    "home.hero.cta2": "Maak gratis account",
    "home.hero.search": "Zoek op stad, bijv. Amsterdam",
    "hero.card.match": "Sterke match",
    "hero.card.matchSub": "past bij jouw profiel",
    "hero.card.alert": "Nieuwe woning in Amsterdam",
    "hero.card.alertSub": "€1.250 · 55m² · zojuist",
    "hero.card.scam": "Scam-check",
    "hero.card.scamSub": "veilig huren",
    "home.hero.badge": "Slim woningplatform",
    "home.usp1.title": "Slimme matchscore",
    "home.usp1.desc": "Zie direct hoe goed een woning bij jouw profiel past.",
    "home.usp2.title": "Directe woningalerts",
    "home.usp2.desc": "Ontvang meteen bericht bij nieuwe passende woningen.",
    "home.usp3.title": "scam-check",
    "home.usp3.desc": "Controleer verdachte advertenties voordat je betaalt.",
    "showcase.tag": "Zo ziet het eruit in de app",
    "showcase.title": "Gebouwd om je sneller aan een woning te helpen",
    "showcase.inapp": "Live in de WoningAlert-app",
    "seo.home.title": "WoningAlert | Huur- en koopwoningen in Nederland",
    "seo.home.desc": "Vind huur- en koopwoningen in heel Nederland. Ontvang woningalerts, ontdek jouw beste matches en vind sneller een woning met WoningAlert.",
    "seo.woningen.title": "Huurwoningen in Nederland",
    "seo.woningen.desc": "Bekijk actuele huurwoningen met een persoonlijke matchscore. Filter op stad, prijs, oppervlakte en meer.",
    "seo.scam.title": "Scam-check voor huuradvertenties",
    "seo.scam.desc": "Controleer gratis of een huuradvertentie te vertrouwen is met onze scam-check.",
    "seo.prijzen.title": "Prijzen & abonnementen",
    "seo.prijzen.desc": "Start gratis en upgrade naar Premium voor onbeperkte scam-checks, slimme tools en meer.",
    "cookie.text": "We gebruiken noodzakelijke cookies om de site te laten werken en, met jouw toestemming, cookies om je ervaring te verbeteren.",
    "cookie.link": "Lees ons cookiebeleid",
    "cookie.accept": "Alles accepteren",
    "cookie.reject": "Alleen noodzakelijk",
    "footer.legal": "Juridisch",
    "footer.privacy": "Privacybeleid",
    "footer.terms": "Voorwaarden",
    "footer.cookies": "Cookiebeleid",
    "footer.rights": "Alle rechten voorbehouden.",
    "footer.about": "Over ons",
    "pf.name": "naam", "pf.age": "leeftijd", "pf.cities": "voorkeurssteden",
    "pf.max_price": "max. budget", "pf.min_m2": "min. oppervlakte", "pf.bedrooms": "slaapkamers",
    "pf.income": "inkomen", "pf.move_date": "verhuisdatum", "pf.phone": "telefoonnummer",
    "pf.contact_email": "contact e-mail", "pf.work_status": "werkstatus", "pf.intro_text": "persoonlijke intro",

    "common.loadFail": "Kon gegevens niet laden.",
    "common.save": "Opslaan",
    "common.cancel": "Annuleren",
    "common.optional": "optioneel",

    "p2.profiel.title": "Zoekprofiel",
    "p2.profiel.subtitle": "Hoe completer je profiel, hoe beter je matches.",
    "p2.profiel.about": "Over jou",
    "p2.profiel.age": "Leeftijd",
    "p2.profiel.household": "Huishouden",
    "p2.profiel.hh.alleen": "Alleenstaand",
    "p2.profiel.hh.samen": "Samenwonend",
    "p2.profiel.hh.gezin": "Gezin",
    "p2.profiel.income": "Bruto jaarinkomen (€)",
    "p2.profiel.work": "Werk / status",
    "p2.profiel.what": "Wat zoek je?",
    "p2.profiel.cities": "Steden (komma-gescheiden)",
    "p2.profiel.maxrent": "Max. huur (€)",
    "p2.profiel.type": "Type woning",
    "p2.profiel.t.appartement": "Appartement",
    "p2.profiel.t.studio": "Studio",
    "p2.profiel.t.huis": "Huis",
    "p2.profiel.t.kamer": "Kamer",
    "p2.profiel.furnish": "Inrichting",
    "p2.profiel.f.egaal": "Maakt niet uit",
    "p2.profiel.f.gemeubileerd": "Gemeubileerd",
    "p2.profiel.f.ongemeubileerd": "Ongemeubileerd",
    "p2.profiel.movedate": "Verhuisdatum",
    "p2.profiel.pets": "Huisdieren",
    "p2.profiel.contact": "Contact & motivatie",
    "p2.profiel.phone": "Telefoon",
    "p2.profiel.cemail": "Contact e-mail",
    "p2.profiel.intro": "Korte introductie (voor je reacties)",
    "p2.profiel.introPh": "Vertel kort wie je bent en waarom je een betrouwbare huurder bent.",
    "p2.profiel.save": "Profiel opslaan",
    "p2.profiel.subscription": "Abonnement",
    "p2.profiel.subActive": "Je hebt WoningAlert Premium actief.",
    "p2.profiel.subManage": "Abonnement beheren / opzeggen",
    "p2.profiel.subNote": "Direct betalen, geen gratis proefperiode. Je kunt op elk moment opzeggen; reeds betaalde periodes komen niet in aanmerking voor een refund.",
    "p2.profiel.subError": "Kon het abonnementsbeheer niet openen. Probeer het opnieuw.",

    "p2.profiel.errName": "Vul je naam in.",
    "p2.profiel.saved": "Profiel opgeslagen! ± {n} matches per week.",

    "p2.alerts.title": "Woningalerts",
    "p2.alerts.subtitle": "Ontvang direct bericht bij nieuwe passende woningen.",
    "p2.alerts.new": "Nieuwe alert",
    "p2.alerts.newTitle": "Nieuwe woningalert",
    "p2.alerts.city": "Stad",
    "p2.alerts.maxprice": "Max. huurprijs (€)",
    "p2.alerts.minbeds": "Min. slaapkamers",
    "p2.alerts.freq": "Frequentie",
    "p2.alerts.create": "Alert aanmaken",
    "p2.alerts.errCity": "Vul een stad in.",
    "p2.alerts.created": "Alert aangemaakt.",
    "p2.alerts.paused": "Gepauzeerd",
    "p2.alerts.empty": "Je hebt nog geen alerts. Maak er een aan om niets te missen.",
    "p2.freq.direct": "Direct",
    "p2.freq.daily": "Dagelijks",
    "p2.freq.weekly": "Wekelijks",

    "p2.reacties.title": "Mijn reacties",
    "p2.reacties.subtitle": "Houd bij op welke woningen je hebt gereageerd en de status ervan.",
    "p2.reacties.empty": "Nog geen reacties. Reageer op een woning om te beginnen.",
    "p2.reacties.viewHomes": "Bekijk woningen",
    "p2.st.gereageerd": "Gereageerd",
    "p2.st.uitgenodigd": "Uitgenodigd",
    "p2.st.afgewezen": "Afgewezen",
    "p2.st.ingetrokken": "Ingetrokken",

    "p2.view.title": "Bezichtigingen",
    "p2.view.subtitle": "Plan en beheer je bezichtigingen op één plek.",
    "p2.view.empty": "Nog geen bezichtigingen. Plan er een vanaf een woningpagina.",
    "p2.view.plan": "Bezichtiging plannen",
    "p2.view.datetime": "Datum en tijd",
    "p2.view.agent": "Makelaar",
    "p2.view.notes": "Notities",
    "p2.view.planBtn": "Plannen",
    "p2.view.errDate": "Kies een datum en tijd.",
    "p2.view.planned": "Bezichtiging gepland. Bekijk hem bij 'Bezichtigingen'.",
    "p2.vst.gepland": "Gepland",
    "p2.vst.bezocht": "Bezocht",
    "p2.vst.afgewezen": "Afgewezen",
    "p2.vst.geannuleerd": "Geannuleerd",

    "p2.vault.title": "Documentenkluis",
    "p2.vault.subtitle": "Bewaar je huurdocumenten veilig en genereer in één klik een compleet huurdossier.",
    "p2.vault.upload": "Uploaden",
    "p2.vault.uploadTitle": "Document uploaden",
    "p2.vault.docType": "Type document",
    "p2.vault.name": "Naam",
    "p2.vault.pick": "Klik om te kiezen (PDF/JPG/PNG, max 8 MB)",
    "p2.vault.add": "Toevoegen",
    "p2.vault.errType": "Alleen PDF, JPG, PNG of WebP.",
    "p2.vault.errSize": "Bestand te groot (max 8 MB).",
    "p2.vault.errPick": "Kies een bestand.",
    "p2.vault.added": "Document toegevoegd.",
    "p2.vault.genTitle": "Huurdossier-generator",
    "p2.vault.genDesc": "Bundel je documenten + motivatiebrief tot één professioneel PDF.",
    "p2.vault.genBtn": "Genereer dossier",
    "p2.vault.genModal": "Huurdossier genereren",
    "p2.vault.premiumNote": "Dit is een Premium-functie. Upgrade om je dossier te genereren.",
    "p2.vault.tone": "Toon van de motivatiebrief",
    "p2.vault.toneLong": "Uitgebreid",
    "p2.vault.toneShort": "Kort & krachtig",
    "p2.vault.genConfirm": "Genereer & download",
    "p2.vault.generating": "Genereren…",
    "p2.vault.generated": "Huurdossier gegenereerd en gedownload.",
    "p2.vault.empty": "Je kluis is leeg. Upload je eerste document.",
    "p2.vault.count": "{n} / {max} documenten",
    "p2.dt.loonstrook": "Loonstrook",
    "p2.dt.id": "ID-bewijs",
    "p2.dt.werkgever": "Werkgeversverklaring",
    "p2.dt.uittreksel": "Uittreksel BRP",
    "p2.dt.huurverklaring": "Verhuurdersverklaring",
    "p2.dt.overig": "Overig",

    "p2.ref.title": "Nodig vrienden uit",
    "p2.ref.subtitle": "Deel WoningAlert en verdien samen gratis Premium.",
    "p2.ref.linkLabel": "Jouw persoonlijke uitnodigingslink",
    "p2.ref.copied": "Link gekopieerd!",
    "p2.ref.copyFail": "Kopiëren mislukt",
    "p2.ref.reward": "Je vriend krijgt {invitee} dagen Premium bij aanmelden. Bij {req} aanmeldingen die hun profiel invullen, krijg jij {referrer} dagen Premium.",
    "p2.ref.progress": "Voortgang naar beloning",
    "p2.ref.invited": "Uitgenodigd",
    "p2.ref.qualified": "Gekwalificeerd",
    "p2.ref.premiumDays": "Premium dagen",
    "p2.ref.recent": "Recente uitnodigingen",
    "p2.ref.unknown": "Onbekend",
    "p2.ref.pending": "In behandeling",

    "p2.set.title": "Instellingen",
    "p2.set.lang": "Taal",
    "p2.set.langDesc": "Kies de taal van de app",
    "p2.set.digest": "E-mail digest",
    "p2.set.digestDesc": "Ontvang een overzicht van nieuwe matches",
    "p2.set.off": "Uit",
    "p2.set.marketing": "Marketing e-mails",
    "p2.set.marketingDesc": "Tips, nieuws en aanbiedingen",
    "p2.set.data": "Mijn gegevens",
    "p2.set.dataDesc": "Download een kopie van al je data (AVG)",
    "p2.set.export": "Exporteren",
    "p2.set.exported": "Export gedownload.",
    "p2.set.saved": "Voorkeur opgeslagen.",
    "p2.set.delTitle": "Account verwijderen",
    "p2.set.delDesc": "Permanent en onomkeerbaar",
    "p2.set.delBtn": "Verwijderen",
    "p2.set.delConfirmTitle": "Account permanent verwijderen?",
    "p2.set.delConfirmDesc": "Al je gegevens, profielen, alerts en documenten worden definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
    "p2.set.delYes": "Ja, verwijder",
    "p2.set.deleted": "Account verwijderd.",

    "p2.mk.title": "Makelaar-portaal",
    "p2.mk.subtitle": "Beheer je woningen, bekijk statistieken en kandidaten.",
    "p2.mk.forbidden": "Dit portaal is alleen beschikbaar voor makelaar-accounts. Registreer als makelaar of neem contact op voor een abonnement.",
    "p2.mk.viewPlans": "Bekijk abonnementen",
    "p2.mk.active": "Actieve woningen",
    "p2.mk.views": "Weergaven",
    "p2.mk.leads": "Leads",
    "p2.mk.top": "Best presterende woningen",
    "p2.mk.noListings": "Nog geen woningen gepubliceerd.",
    "p2.kand.title": "Kandidaten",
    "p2.kand.notFound": "Woning niet gevonden of niet van jou.",
    "p2.kand.back": "Terug naar portaal",
    "p2.kand.search": "Zoek kandidaat op naam",
    "p2.kand.sortScore": "Beste match",
    "p2.kand.sortRecent": "Meest recent",
    "p2.kand.disclaimer": "De matchscore is een objectief hulpmiddel op basis van harde criteria. Alle kandidaten blijven altijd zichtbaar — er wordt niemand automatisch afgewezen.",
    "p2.kand.empty": "Nog geen kandidaten voor deze woning.",
    "p2.kand.candidate": "Kandidaat",
    "p2.kand.assessment": "Beoordeling",
    "p2.kand.loadFail": "Kon kandidaat niet laden.",
    "home.cities.title": "Populaire steden",
    "home.recommended.title": "Aanbevolen woningen",
    "home.cta.title": "Klaar om je droomwoning te vinden?",
    "home.cta.desc": "Maak een gratis profiel aan en ontvang matches die echt bij je passen.",
    "demo.tag": "Probeer gratis — geen account nodig",
    "demo.title": "Is deze advertentie te vertrouwen?",
    "demo.subtitle": "Plak de tekst van een huuradvertentie en wij checken direct op oplichtingssignalen.",
    "demo.placeholder": "Plak hier de volledige advertentietekst (bijv. 'Prachtig appartement, €650/mnd, borg vooraf overmaken, geen bezichtiging mogelijk...')",
    "demo.analyze": "Analyseer op oplichting",
    "demo.analyzing": "Analyseren…",
    "demo.trust": "Vertrouwensscore",
    "demo.redflags": "Signalen",
    "demo.remaining": "Nog {n} gratis demo-checks vandaag",
    "demo.cta": "Maak gratis account voor onbeperkte checks",
    "demo.minlen": "Plak minstens een paar zinnen advertentietekst.",
    "demo.result.safe": "Ziet er betrouwbaar uit",
    "demo.result.caution": "Wees voorzichtig",
    "demo.result.danger": "Hoog risico op oplichting",

    // listings
    "woningen.title": "Woningen",
    "woningen.count": "{n} woningen gevonden",
    "woningen.filters": "Filters",
    "woningen.reset": "Reset",
    "woningen.apply": "Toon woningen",
    "woningen.empty": "Geen woningen gevonden. Pas je filters aan.",
    "woningen.loadMore": "Meer woningen laden",

    "woningen.noFilters": "Alle woningen",
    "woningen.f.city": "Stad",
    "woningen.f.maxprice": "Max. huurprijs",
    "woningen.f.price": "Prijs",
    "woningen.f.bedrooms": "Min. slaapkamers",
    "woningen.f.minm2": "Min. oppervlakte (m²)",
    "woningen.f.furnished": "Gemeubileerd",
    "woningen.f.pets": "Huisdieren toegestaan",
    "woningen.f.energy": "Energielabel",
    "woningen.sort": "Sorteren",
    "woningen.sort.newest": "Nieuwste",
    "woningen.sort.price_asc": "Prijs (laag → hoog)",
    "woningen.sort.match_desc": "Beste match",
    "woningen.sort.size_desc": "Grootste eerst",

    // detail
    "detail.match.title": "Waarom past deze woning bij jou?",
    "detail.facts": "Kenmerken",
    "detail.description": "Omschrijving",
    "detail.location": "Locatie",
    "detail.energy": "Energielabel",
    "detail.m2": "Oppervlakte",
    "detail.bedrooms": "Slaapkamers",
    "detail.available": "Beschikbaar vanaf",
    "detail.income": "Inkomenseis",
    "detail.type": "Type",
    "detail.apply": "Reageer op woning",
    "detail.favorite": "Bewaren",
    "detail.favorited": "Bewaard",
    "detail.notfound": "Woning niet gevonden.",
    "detail.scamHint": "Twijfel je over deze advertentie? Gebruik de scam-check.",
    "detail.translate": "Vertaal naar Engels",
    "detail.responded": "Je reactie is geregistreerd.",

    // scam
    "scam.title": "Scam-check",
    "scam.subtitle": "Controleer of een huurwoning-advertentie te vertrouwen is.",
    "scam.url": "URL van de advertentie (optioneel)",
    "scam.price": "Vraagprijs per maand (€)",
    "scam.location": "Locatie (optioneel)",
    "scam.description": "Beschrijving / advertentietekst",
    "scam.submit": "Controleer advertentie",
    "scam.analyzing": "Bezig met analyseren…",
    "scam.risk.laag": "Laag risico",
    "scam.risk.gemiddeld": "Gemiddeld risico",
    "scam.risk.hoog": "Hoog risico",
    "scam.redflags": "Waarschuwingssignalen",
    "scam.recommendations": "Aanbevelingen",
    "scam.loginRequired": "Log in om de scam-check te gebruiken.",
    "scam.quota": "Nog {n} gratis checks deze week",
    "scam.quotaUnlimited": "Onbeperkte checks (Premium)",

    // pricing
    "prijzen.title": "Kies het abonnement dat bij je past",
    "prijzen.subtitle": "Start gratis. Upgrade wanneer je meer wilt.",
    "prijzen.month": "/maand",
    "prijzen.choose": "Kies abonnement",
    "prijzen.current": "Huidig plan",
    "prijzen.popular": "Meest gekozen",
    "prijzen.waitlist": "Zet op wachtlijst",
    "prijzen.free.name": "Gratis",
    "prijzen.premium.name": "Premium",
    "prijzen.waitCount": "{n} mensen op de wachtlijst",
    "prijzen.waitSuccess": "Je staat op de wachtlijst! We laten het weten zodra Premium live gaat.",
    "prijzen.checkoutError": "Er ging iets mis bij het starten van de betaling. Probeer het opnieuw of neem contact op.",
    "prijzen.billingNote": "Directe betaling, geen gratis proefperiode. Maandelijks opzegbaar. Reeds betaalde periodes komen niet in aanmerking voor een refund.",

    "prijzen.free.f1": "Alle woningen bekijken",
    "prijzen.free.f2": "Basis matchscore",
    "prijzen.free.f3": "3 scam-checks per week",
    "prijzen.free.f4": "Tot 10 favorieten",
    "prijzen.premium.f1": "Onbeperkte scam-checks",
    "prijzen.premium.f2": "Reactiebrief-generator",
    "prijzen.premium.f3": "Foto-analyse",
    "prijzen.premium.f4": "Onbeperkte favorieten & alerts",
    "prijzen.premium.f5": "Persoonlijke matchscore + uitleg",
    "detail.loginForScore": "Log in voor je persoonlijke matchscore.",

    // dashboard
    "dash.welcome": "Welkom terug, {name}",
    "dash.stat.alerts": "Actieve alerts",
    "dash.stat.saved": "Bewaarde woningen",
    "dash.stat.matches": "Nieuwe matches",
    "dash.matches.title": "Matches voor jou",
    "dash.recent.title": "Recent bekeken",
    "dash.profile.title": "Profiel compleetheid",
    "dash.profile.missing": "Nog aan te vullen:",
    "dash.empty.matches": "Nog geen matches. Vul je zoekprofiel aan voor betere resultaten.",

    // auth
    "auth.login.title": "Inloggen",
    "auth.login.submit": "Inloggen",
    "auth.login.noAccount": "Nog geen account?",
    "auth.login.forgot": "Wachtwoord vergeten?",
    "auth.register.title": "Account aanmaken",
    "auth.register.submit": "Account aanmaken",
    "auth.register.hasAccount": "Heb je al een account?",
    "auth.register.role": "Ik ben een",
    "auth.register.huurder": "Huurder",
    "auth.register.makelaar": "Makelaar",
    "auth.register.terms": "Ik ga akkoord met de voorwaarden",
    "auth.forgot.title": "Wachtwoord vergeten",
    "auth.forgot.subtitle": "Vul je e-mailadres in en we sturen je een reset-link.",
    "auth.forgot.submit": "Stuur reset-link",
    "auth.reset.title": "Nieuw wachtwoord instellen",
    "auth.reset.new": "Nieuw wachtwoord",
    "auth.reset.submit": "Wachtwoord opslaan",
    "auth.err.email": "Vul een geldig e-mailadres in.",
    "auth.err.password": "Wachtwoord moet minstens 6 tekens zijn.",

    // billing
    "billing.success.title": "Bedankt voor je aanmelding!",
    "billing.success.desc": "Je betaling wordt verwerkt. Je Premium-toegang wordt automatisch geactiveerd.",
    "billing.success.cta": "Naar dashboard",
  },
  en: {
    "nav.woningen": "Listings",
    "nav.koop": "Buy",
    "nav.woningwaarde": "Home value",
    "nav.scamcheck": "Scam check",
    "nav.prijzen": "Pricing",
    "nav.dashboard": "Dashboard",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "nav.account": "My account",
    "menu.profiel": "Search profile",
    "menu.vault": "Document vault",
    "menu.alerts": "Alerts",
    "menu.reacties": "My responses",
    "menu.bezichtigingen": "Viewings",
    "menu.referrals": "Invite friends",
    "menu.instellingen": "Settings",
    "menu.makelaar": "Agent portal",
    "menu.section.tenant": "Tenant",
    "menu.section.broker": "Agent",
    "nav.premium": "Premium",
    // Premium hub
    "premium.seo.title": "WoningAlert Premium — everything you need to find a home faster",
    "premium.seo.desc": "Unlock smart tools, unlimited favourites and smart alerts. One subscription, all benefits.",
    "premium.hero.brand": "WoningAlert",
    "premium.hero.freeSub": "Unlock everything you need to find a home faster and smarter.",
    "premium.hero.activeSub": "Your Premium tools are ready below.",
    "premium.hero.cta": "Unlock WoningAlert Premium",
    "premium.pill.active": "Premium active",
    "premium.pill.inactive": "Premium",
    "premium.card.freeLabel": "Free",
    "premium.card.proLabel": "Premium",
    "premium.card.locked": "Locked",
    "premium.card.unlock": "Unlock",
    "premium.card.available": "Available",
    "premium.card.open": "Open tool",
    "premium.card.openFree": "Open",
    "premium.card.coach.title": "Response Coach",
    "premium.card.coach.desc": "Let a smart assistant write a strong, personal application letter based on your profile and the listing.",
    "premium.card.coach.pro": "Unlimited letters for any listing",
    "premium.card.photo.title": "Photo Analysis",
    "premium.card.photo.desc": "Detect damp, mould, poor lighting and maintenance issues from the listing photos.",
    "premium.card.photo.pro": "Unlimited photo analyses",
    "premium.card.scam.title": "Scam Check",
    "premium.card.scam.desc": "Check a listing for suspicious signals before you respond or pay.",
    "premium.card.scam.free": "3 checks per week free",
    "premium.card.scam.pro": "Unlimited checks + priority",
    "premium.card.match.title": "Personal Match Score",
    "premium.card.match.desc": "See at a glance how well a home fits your profile.",
    "premium.card.match.free": "Basic match score on every listing",
    "premium.card.match.pro": "Full score + criterion-by-criterion breakdown",
    "premium.card.vault.title": "Document Vault",
    "premium.card.vault.desc": "Keep documents ready and generate a full tenant dossier in seconds.",
    "premium.card.vault.free": "Store your documents safely",
    "premium.card.vault.pro": "Smart tenant dossier PDF in one click",
    "premium.card.alerts.title": "Smart alerts",
    "premium.card.alerts.desc": "Manage your search profiles and get instant matches.",
    "premium.card.alerts.free": "Basic e-mail alerts",
    "premium.card.alerts.pro": "Multiple search profiles + priority push",
    "premium.card.favs.title": "Favourites",
    "premium.card.favs.desc": "Save listings you want to view or respond to later.",
    "premium.card.favs.free": "Up to 10 favourites",
    "premium.card.favs.pro": "Unlimited favourites",
    "premium.footcta.title": "Find a home faster and smarter",
    "premium.footcta.sub": "Unlock every smart tool, unlimited favourites and smart alerts. Cancel any time.",
    // Premium tools — shared
    "tools.locked.title": "Premium members only",
    "tools.locked.sub": "This tool is part of WoningAlert Premium. Unlock Premium to get started.",
    "tools.locked.cta": "Unlock Premium",
    "tools.coach.seoTitle": "Response Coach — WoningAlert Premium",
    "tools.coach.seoDesc": "Let a smart assistant write a strong application letter based on your profile and the listing.",
    "tools.coach.title": "Response Coach",
    "tools.coach.subtitle": "Get a strong, personal application letter in seconds.",
    "tools.coach.pickListing": "Pick a listing",
    "tools.coach.searchPh": "Search by city, street or title",
    "tools.coach.noneFound": "No listings found.",
    "tools.coach.toneShort": "Short & sharp",
    "tools.coach.toneLong": "Detailed",
    "tools.coach.extraLabel": "Extra info (optional)",
    "tools.coach.extraPh": "E.g. moving reason, pets, household…",
    "tools.coach.generate": "Generate letter",
    "tools.coach.generating": "Generating…",
    "tools.coach.error": "Could not generate the letter. Try again.",
    "tools.coach.emptyHint": "Pick a listing on the left to get started.",
    "tools.coach.readyHint": "Ready to generate a response for: {title}",
    "tools.coach.copy": "Copy",
    "tools.coach.copied": "Copied",
    "tools.coach.result.subject": "Subject",
    "tools.coach.result.letter": "Application letter",
    "tools.coach.result.tips": "Follow-up tips",
    "tools.photo.seoTitle": "Photo Analysis — WoningAlert Premium",
    "tools.photo.seoDesc": "Analyse listing photos for damp, mould and maintenance issues.",
    "tools.photo.title": "Photo Analysis",
    "tools.photo.subtitle": "Spot damp, mould and maintenance issues before you respond.",
    "tools.photo.pickListing": "Pick a listing to analyse",
    "tools.photo.searchPh": "Search by city, street or title",
    "tools.photo.analyse": "Analyse photos",
    "tools.photo.analysing": "Analysing…",
    "tools.photo.error": "Could not run the analysis. Try again.",
    "tools.photo.emptyHint": "Pick a listing on the left to get started.",
    "tools.photo.readyHint": "Ready to analyse photos for: {title}",
    "tools.photo.result.score": "Overall condition score",
    "tools.photo.result.positives": "Positives",
    "tools.photo.result.concerns": "Concerns",
    "tools.photo.result.questions": "Questions to ask at the viewing",
    "tools.photo.result.photoCount": "{n} photos analysed",
    // Dashboard premium card
    "dash.premium.title": "WoningAlert Premium",
    "dash.premium.sub": "Your Premium tools are ready.",
    "dash.premium.cta": "Open Premium",
    "dash.upsell.title": "Unlock Premium",
    "dash.upsell.sub": "See every Premium tool you haven't used yet.",
    "dash.upsell.cta": "See Premium",
    "scam.nudge.title": "This check was free",
    "scam.nudge.body": "Premium gives you unlimited Scam Checks plus Response Coach and Photo Analysis.",
    "scam.nudge.cta": "See Premium",
    "scam.nudge.pricing": "View pricing",
    "common.loading": "Loading…",
    "common.retry": "Try again",
    "common.error": "Something went wrong. Please try again.",
    "common.perMonth": "/mo",
    "common.rooms": "rooms",
    "common.beds": "beds",
    "common.match": "Match",
    "common.live": "Live",
    "common.soon": "Soon",
    "common.viewAll": "View all",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Name",
    "common.back": "Back",

    "home.hero.title": "Find your next home faster",
    "home.hero.subtitle":
      "Rent or buy? Discover homes that truly match you with our unique matching system.",
    "home.hero.cta": "Browse listings",
    "home.hero.cta2": "Create free account",
    "home.hero.search": "Search by city, e.g. Amsterdam",
    "hero.card.match": "Strong match",
    "hero.card.matchSub": "fits your profile",
    "hero.card.alert": "New home in Amsterdam",
    "hero.card.alertSub": "€1,250 · 55m² · just now",
    "hero.card.scam": "Scam check",
    "hero.card.scamSub": "rent safely",
    "home.hero.badge": "Smart housing platform",
    "home.usp1.title": "Smart match score",
    "home.usp1.desc": "Instantly see how well a home fits your profile.",
    "home.usp2.title": "Instant alerts",
    "home.usp2.desc": "Get notified the moment a matching home appears.",
    "home.usp3.title": "scam check",
    "home.usp3.desc": "Verify suspicious listings before you pay.",
    "showcase.tag": "This is how it looks in the app",
    "showcase.title": "Built to help you find a home faster",
    "showcase.inapp": "Live in the WoningAlert app",
    "seo.home.title": "WoningAlert | Rent & buy homes across the Netherlands",
    "seo.home.desc": "Find rental and for-sale homes across the Netherlands. Get woningalerts, discover your best matches and find a home faster with WoningAlert.",
    "seo.woningen.title": "Rental homes in the Netherlands",
    "seo.woningen.desc": "Browse current rentals with a personal match score. Filter by city, price, size and more.",
    "seo.scam.title": "scam check for rental listings",
    "seo.scam.desc": "Check for free whether a rental listing can be trusted with our scam check.",
    "seo.prijzen.title": "Pricing & plans",
    "seo.prijzen.desc": "Start for free and upgrade to Premium for unlimited scam checks, smart tools and more.",
    "cookie.text": "We use necessary cookies to make the site work and, with your consent, cookies to improve your experience.",
    "cookie.link": "Read our cookie policy",
    "cookie.accept": "Accept all",
    "cookie.reject": "Necessary only",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy policy",
    "footer.terms": "Terms",
    "footer.cookies": "Cookie policy",
    "footer.rights": "All rights reserved.",
    "footer.about": "About us",
    "pf.name": "name", "pf.age": "age", "pf.cities": "preferred cities",
    "pf.max_price": "max. budget", "pf.min_m2": "min. size", "pf.bedrooms": "bedrooms",
    "pf.income": "income", "pf.move_date": "move-in date", "pf.phone": "phone number",
    "pf.contact_email": "contact email", "pf.work_status": "work status", "pf.intro_text": "personal intro",

    "common.loadFail": "Could not load data.",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.optional": "optional",

    "p2.profiel.title": "Search profile",
    "p2.profiel.subtitle": "The more complete your profile, the better your matches.",
    "p2.profiel.about": "About you",
    "p2.profiel.age": "Age",
    "p2.profiel.household": "Household",
    "p2.profiel.hh.alleen": "Single",
    "p2.profiel.hh.samen": "Living together",
    "p2.profiel.hh.gezin": "Family",
    "p2.profiel.income": "Gross annual income (€)",
    "p2.profiel.work": "Work / status",
    "p2.profiel.what": "What are you looking for?",
    "p2.profiel.cities": "Cities (comma-separated)",
    "p2.profiel.maxrent": "Max. rent (€)",
    "p2.profiel.type": "Property type",
    "p2.profiel.t.appartement": "Apartment",
    "p2.profiel.t.studio": "Studio",
    "p2.profiel.t.huis": "House",
    "p2.profiel.t.kamer": "Room",
    "p2.profiel.furnish": "Furnishing",
    "p2.profiel.f.egaal": "No preference",
    "p2.profiel.f.gemeubileerd": "Furnished",
    "p2.profiel.f.ongemeubileerd": "Unfurnished",
    "p2.profiel.movedate": "Move-in date",
    "p2.profiel.pets": "Pets",
    "p2.profiel.subscription": "Subscription",
    "p2.profiel.subActive": "You have WoningAlert Premium active.",
    "p2.profiel.subManage": "Manage / cancel subscription",
    "p2.profiel.subNote": "Immediate payment, no free trial. You can cancel anytime; already-paid periods are not eligible for a refund.",
    "p2.profiel.subError": "Could not open subscription management. Please try again.",

    "p2.profiel.contact": "Contact & motivation",
    "p2.profiel.phone": "Phone",
    "p2.profiel.cemail": "Contact email",
    "p2.profiel.intro": "Short introduction (for your responses)",
    "p2.profiel.introPh": "Briefly tell who you are and why you're a reliable tenant.",
    "p2.profiel.save": "Save profile",
    "p2.profiel.errName": "Enter your name.",
    "p2.profiel.saved": "Profile saved! ± {n} matches per week.",

    "p2.alerts.title": "Home alerts",
    "p2.alerts.subtitle": "Get notified instantly about new matching homes.",
    "p2.alerts.new": "New alert",
    "p2.alerts.newTitle": "New home alert",
    "p2.alerts.city": "City",
    "p2.alerts.maxprice": "Max. rent (€)",
    "p2.alerts.minbeds": "Min. bedrooms",
    "p2.alerts.freq": "Frequency",
    "p2.alerts.create": "Create alert",
    "p2.alerts.errCity": "Enter a city.",
    "p2.alerts.created": "Alert created.",
    "p2.alerts.paused": "Paused",
    "p2.alerts.empty": "You don't have any alerts yet. Create one so you never miss out.",
    "p2.freq.direct": "Instant",
    "p2.freq.daily": "Daily",
    "p2.freq.weekly": "Weekly",

    "p2.reacties.title": "My responses",
    "p2.reacties.subtitle": "Track which homes you responded to and their status.",
    "p2.reacties.empty": "No responses yet. Respond to a home to get started.",
    "p2.reacties.viewHomes": "Browse listings",
    "p2.st.gereageerd": "Responded",
    "p2.st.uitgenodigd": "Invited",
    "p2.st.afgewezen": "Rejected",
    "p2.st.ingetrokken": "Withdrawn",

    "p2.view.title": "Viewings",
    "p2.view.subtitle": "Plan and manage your viewings in one place.",
    "p2.view.empty": "No viewings yet. Plan one from a listing page.",
    "p2.view.plan": "Plan a viewing",
    "p2.view.datetime": "Date and time",
    "p2.view.agent": "Agent",
    "p2.view.notes": "Notes",
    "p2.view.planBtn": "Plan",
    "p2.view.errDate": "Pick a date and time.",
    "p2.view.planned": "Viewing planned. Find it under 'Viewings'.",
    "p2.vst.gepland": "Planned",
    "p2.vst.bezocht": "Visited",
    "p2.vst.afgewezen": "Rejected",
    "p2.vst.geannuleerd": "Cancelled",

    "p2.vault.title": "Document vault",
    "p2.vault.subtitle": "Store your rental documents securely and generate a complete rental dossier in one click.",
    "p2.vault.upload": "Upload",
    "p2.vault.uploadTitle": "Upload document",
    "p2.vault.docType": "Document type",
    "p2.vault.name": "Name",
    "p2.vault.pick": "Click to choose (PDF/JPG/PNG, max 8 MB)",
    "p2.vault.add": "Add",
    "p2.vault.errType": "Only PDF, JPG, PNG or WebP.",
    "p2.vault.errSize": "File too large (max 8 MB).",
    "p2.vault.errPick": "Choose a file.",
    "p2.vault.added": "Document added.",
    "p2.vault.genTitle": "Rental dossier generator",
    "p2.vault.genDesc": "Bundle your documents + cover letter into one professional PDF.",
    "p2.vault.genBtn": "Generate dossier",
    "p2.vault.genModal": "Generate rental dossier",
    "p2.vault.premiumNote": "This is a Premium feature. Upgrade to generate your dossier.",
    "p2.vault.tone": "Cover letter tone",
    "p2.vault.toneLong": "Detailed",
    "p2.vault.toneShort": "Short & punchy",
    "p2.vault.genConfirm": "Generate & download",
    "p2.vault.generating": "Generating…",
    "p2.vault.generated": "Rental dossier generated and downloaded.",
    "p2.vault.empty": "Your vault is empty. Upload your first document.",
    "p2.vault.count": "{n} / {max} documents",
    "p2.dt.loonstrook": "Payslip",
    "p2.dt.id": "ID document",
    "p2.dt.werkgever": "Employer statement",
    "p2.dt.uittreksel": "Municipal extract (BRP)",
    "p2.dt.huurverklaring": "Landlord reference",
    "p2.dt.overig": "Other",

    "p2.ref.title": "Invite friends",
    "p2.ref.subtitle": "Share WoningAlert and earn free Premium together.",
    "p2.ref.linkLabel": "Your personal invite link",
    "p2.ref.copied": "Link copied!",
    "p2.ref.copyFail": "Copy failed",
    "p2.ref.reward": "Your friend gets {invitee} days of Premium on sign-up. At {req} sign-ups who complete their profile, you get {referrer} days of Premium.",
    "p2.ref.progress": "Progress to reward",
    "p2.ref.invited": "Invited",
    "p2.ref.qualified": "Qualified",
    "p2.ref.premiumDays": "Premium days",
    "p2.ref.recent": "Recent invitations",
    "p2.ref.unknown": "Unknown",
    "p2.ref.pending": "Pending",

    "p2.set.title": "Settings",
    "p2.set.lang": "Language",
    "p2.set.langDesc": "Choose the app language",
    "p2.set.digest": "Email digest",
    "p2.set.digestDesc": "Receive a summary of new matches",
    "p2.set.off": "Off",
    "p2.set.marketing": "Marketing emails",
    "p2.set.marketingDesc": "Tips, news and offers",
    "p2.set.data": "My data",
    "p2.set.dataDesc": "Download a copy of all your data (GDPR)",
    "p2.set.export": "Export",
    "p2.set.exported": "Export downloaded.",
    "p2.set.saved": "Preference saved.",
    "p2.set.delTitle": "Delete account",
    "p2.set.delDesc": "Permanent and irreversible",
    "p2.set.delBtn": "Delete",
    "p2.set.delConfirmTitle": "Permanently delete account?",
    "p2.set.delConfirmDesc": "All your data, profiles, alerts and documents will be permanently deleted. This cannot be undone.",
    "p2.set.delYes": "Yes, delete",
    "p2.set.deleted": "Account deleted.",

    "p2.mk.title": "Agent portal",
    "p2.mk.subtitle": "Manage your listings, view stats and candidates.",
    "p2.mk.forbidden": "This portal is only available for agent accounts. Register as an agent or contact us for a subscription.",
    "p2.mk.viewPlans": "View plans",
    "p2.mk.active": "Active listings",
    "p2.mk.views": "Views",
    "p2.mk.leads": "Leads",
    "p2.mk.top": "Top performing listings",
    "p2.mk.noListings": "No listings published yet.",
    "p2.kand.title": "Candidates",
    "p2.kand.notFound": "Listing not found or not yours.",
    "p2.kand.back": "Back to portal",
    "p2.kand.search": "Search candidate by name",
    "p2.kand.sortScore": "Best match",
    "p2.kand.sortRecent": "Most recent",
    "p2.kand.disclaimer": "The match score is an objective tool based on hard criteria. All candidates always remain visible — no one is automatically rejected.",
    "p2.kand.empty": "No candidates for this listing yet.",
    "p2.kand.candidate": "Candidate",
    "p2.kand.assessment": "Assessment",
    "p2.kand.loadFail": "Could not load candidate.",
    "home.cities.title": "Popular cities",
    "home.recommended.title": "Recommended homes",
    "home.cta.title": "Ready to find your dream home?",
    "home.cta.desc": "Create a free profile and receive matches that truly fit you.",
    "demo.tag": "Try it free — no account needed",
    "demo.title": "Can this listing be trusted?",
    "demo.subtitle": "Paste a rental listing and we'll instantly check for scam signals.",
    "demo.placeholder": "Paste the full listing text here (e.g. 'Beautiful apartment, €650/mo, transfer deposit upfront, no viewing possible...')",
    "demo.analyze": "Analyze for scams",
    "demo.analyzing": "Analyzing…",
    "demo.trust": "Trust score",
    "demo.redflags": "Signals",
    "demo.remaining": "{n} free demo checks left today",
    "demo.cta": "Create a free account for unlimited checks",
    "demo.minlen": "Paste at least a few sentences of listing text.",
    "demo.result.safe": "Looks trustworthy",
    "demo.result.caution": "Be careful",
    "demo.result.danger": "High scam risk",

    "woningen.title": "Listings",
    "woningen.count": "{n} homes found",
    "woningen.filters": "Filters",
    "woningen.reset": "Reset",
    "woningen.apply": "Show homes",
    "woningen.empty": "No homes found. Adjust your filters.",
    "woningen.loadMore": "Load more homes",

    "woningen.noFilters": "All homes",
    "woningen.f.city": "City",
    "woningen.f.maxprice": "Max. rent",
    "woningen.f.price": "Price",
    "woningen.f.bedrooms": "Min. bedrooms",
    "woningen.f.minm2": "Min. size (m²)",
    "woningen.f.furnished": "Furnished",
    "woningen.f.pets": "Pets allowed",
    "woningen.f.energy": "Energy label",
    "woningen.sort": "Sort",
    "woningen.sort.newest": "Newest",
    "woningen.sort.price_asc": "Price (low → high)",
    "woningen.sort.match_desc": "Best match",
    "woningen.sort.size_desc": "Largest first",

    "detail.match.title": "Why does this home match you?",
    "detail.facts": "Facts",
    "detail.description": "Description",
    "detail.location": "Location",
    "detail.energy": "Energy label",
    "detail.m2": "Size",
    "detail.bedrooms": "Bedrooms",
    "detail.available": "Available from",
    "detail.income": "Income requirement",
    "detail.type": "Type",
    "detail.apply": "Apply to this home",
    "detail.favorite": "Save",
    "detail.favorited": "Saved",
    "detail.notfound": "Home not found.",
    "detail.scamHint": "Not sure about this listing? Run the scam check.",
    "detail.translate": "Translate to English",
    "detail.responded": "Your response has been recorded.",

    "scam.title": "Scam check",
    "scam.subtitle": "Check whether a rental listing can be trusted.",
    "scam.url": "Listing URL (optional)",
    "scam.price": "Asking price per month (€)",
    "scam.location": "Location (optional)",
    "scam.description": "Description / listing text",
    "scam.submit": "Check listing",
    "scam.analyzing": "Analyzing…",
    "scam.risk.laag": "Low risk",
    "scam.risk.gemiddeld": "Medium risk",
    "scam.risk.hoog": "High risk",
    "scam.redflags": "Warning signs",
    "scam.recommendations": "Recommendations",
    "scam.loginRequired": "Log in to use the scam check.",
    "scam.quota": "{n} free checks left this week",
    "scam.quotaUnlimited": "Unlimited checks (Premium)",

    "prijzen.title": "Choose the plan that fits you",
    "prijzen.subtitle": "Start for free. Upgrade whenever you want.",
    "prijzen.month": "/month",
    "prijzen.choose": "Choose plan",
    "prijzen.current": "Current plan",
    "prijzen.popular": "Most popular",
    "prijzen.waitlist": "Join waitlist",
    "prijzen.free.name": "Free",
    "prijzen.premium.name": "Premium",
    "prijzen.waitCount": "{n} people on the waitlist",
    "prijzen.waitSuccess": "You're on the waitlist! We'll let you know as soon as Premium goes live.",
    "prijzen.checkoutError": "Something went wrong starting the payment. Please try again or contact us.",
    "prijzen.billingNote": "Immediate payment, no free trial. Cancel monthly. Already-paid periods are not eligible for a refund.",

    "prijzen.free.f1": "Browse all homes",
    "prijzen.free.f2": "Basic match score",
    "prijzen.free.f3": "3 scam checks per week",
    "prijzen.free.f4": "Up to 10 favorites",
    "prijzen.premium.f1": "Unlimited scam checks",
    "prijzen.premium.f2": "Response-letter generator",
    "prijzen.premium.f3": "photo analysis",
    "prijzen.premium.f4": "Unlimited favorites & alerts",
    "prijzen.premium.f5": "Personal match score + explanation",
    "detail.loginForScore": "Log in for your personal match score.",

    "dash.welcome": "Welcome back, {name}",
    "dash.stat.alerts": "Active alerts",
    "dash.stat.saved": "Saved homes",
    "dash.stat.matches": "New matches",
    "dash.matches.title": "Matches for you",
    "dash.recent.title": "Recently viewed",
    "dash.profile.title": "Profile completeness",
    "dash.profile.missing": "Still to add:",
    "dash.empty.matches": "No matches yet. Complete your search profile for better results.",

    "auth.login.title": "Log in",
    "auth.login.submit": "Log in",
    "auth.login.noAccount": "No account yet?",
    "auth.login.forgot": "Forgot password?",
    "auth.register.title": "Create account",
    "auth.register.submit": "Create account",
    "auth.register.hasAccount": "Already have an account?",
    "auth.register.role": "I am a",
    "auth.register.huurder": "Tenant",
    "auth.register.makelaar": "Agent",
    "auth.register.terms": "I agree to the terms",
    "auth.forgot.title": "Forgot password",
    "auth.forgot.subtitle": "Enter your email and we'll send you a reset link.",
    "auth.forgot.submit": "Send reset link",
    "auth.reset.title": "Set a new password",
    "auth.reset.new": "New password",
    "auth.reset.submit": "Save password",
    "auth.err.email": "Enter a valid email address.",
    "auth.err.password": "Password must be at least 6 characters.",

    "billing.success.title": "Thanks for signing up!",
    "billing.success.desc": "Your payment is being processed. Your Premium access will activate automatically.",
    "billing.success.cta": "Go to dashboard",
  },
};

function detectLang() {
  try {
    const raw = (navigator.language || "nl").toLowerCase();
    if (raw.startsWith("nl")) return "nl";
    return "en";
  } catch {
    return "nl";
  }
}

function interpolate(template, params) {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => (params[k] !== undefined ? String(params[k]) : `{${k}}`));
}

const I18nContext = createContext({ lang: "nl", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "nl" || stored === "en") return stored;
    } catch (e) {
      console.warn("Taalvoorkeur lezen mislukt:", e);
    }
    return detectLang();
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch (e) {
      console.warn("Taalvoorkeur opslaan mislukt:", e);
    }
  }, []);

  const t = useCallback(
    (key, params) => {
      const table = dict[lang] || dict.nl;
      const value = table[key] ?? dict.nl[key] ?? key;
      return interpolate(value, params);
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useT() {
  return useContext(I18nContext);
}
